// The React context for the theme hook. It lives in its own plain file so the layout seam
// (layouts.js) can read it without importing the hook's JSX.
import { createContext } from 'react'

export const ThemeContext = createContext(null)
